import { PIN_CATEGORIES } from '../constants';

export const newPinId = 'add';

export const forms = {
    addPinForm: 'addPinForm',
    updatePinForm: 'updatePinForm',
};

export const pinFields = {
    title: 'title',
    subtitle: 'subtitle',
    category: 'category',
    color: 'color',
};

export const requiredFields = [pinFields.title];
export const localizableFields = [pinFields.title, pinFields.subtitle];

export const defaultValues = {
    [pinFields.category]: PIN_CATEGORIES[0],
};
